import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import './RepAssignmentModal.css'
import { Row, Col, Alert, Progress, Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, Label } from 'reactstrap'
import { RepsQuery } from "../Functions/querys"
import withApolloClient from '../withApolloClient'
import Select from 'react-select'
import toTitleCase from '../Functions/toTitleCase'
const autoAssignRep = gql`
mutation CreateAutoAssignment ($input:CreateAutoDriverAssignmentInput!){
    createAutoAssignment(input:$input){
        errors{
            messages
        }
        ok
        assignment{
            id
        }
    }
}`

class RepAssignmentModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedReps: [],
            loading: false,
            error: null,
            assignmentSuccess: false,
            selectedCategory: (Array.isArray(props.assignmentCategory) && props.assignmentCategory.length === 1) ? props.assignmentCategory[0] : ''
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.assignmentCategory !== this.props.assignmentCategory) {
            if (Array.isArray(this.props.assignmentCategory) && this.props.assignmentCategory.length === 1) {
                this.setState({ selectedCategory: this.props.assignmentCategory[0] })
            } else {
                this.setState({ selectedCategory: '' })
            }
        }
    }

    toggleRep = (repId) => {
        let selectedReps = this.state.selectedReps
        if (selectedReps.includes(repId)) {
            selectedReps = selectedReps.filter(rep => rep !== repId)
        } else {
            selectedReps.push(repId)
        }
        this.setState({ selectedReps: selectedReps })
    }

    handleClose = () => {
        this.setState({ selectedReps: [], assignmentSuccess: false, error: null, loading: false })
        this.props.handleClose()
    }

    handleCategoryChange = (selectedOption) => {
        this.setState({ selectedCategory: selectedOption ? selectedOption.value : '' })
    }

    runAutoAssign = () => {
        if (
            Array.isArray(this.props.assignmentCategory) &&
            this.props.assignmentCategory.length > 1 &&
            !this.state.selectedCategory
        ) {
            this.setState({ error: 'Please select an assignment category.' })
            return
        }
        this.setState({ loading: true })
        let input = {
            reps: this.state.selectedReps,
            assignmentCategory: this.state.selectedCategory
        }
        if (this.props.filterValues)
            input["filterValues"] = this.props.filterValues
        else
            input["drivers"] = this.props.drivers


        this.props.apolloClient.mutate({
            mutation: autoAssignRep,
            variables: { input },
        }).then((result) => {
            if (result.data && result.data.createAutoAssignment && result.data.createAutoAssignment.ok) {
                this.setState({ loading: false, error: null, assignmentSuccess: true })
                if (this.props.refetchDrivers) {
                    this.props.refetchDrivers()
                } else if (this.props.handleSuccess) {
                    this.props.handleSuccess()
                }
            } else {
                this.setState({ assignmentSuccess: false, loading: false, error: "Error auto assigning. Try again" })
            }
        }).catch((error) => {
            this.setState({ error: error.message, loading: false, assignmentSuccess: false })
        })
    };

    render() {
        const categoryOptions = (Array.isArray(this.props.assignmentCategory) ? this.props.assignmentCategory : []).map(cat => ({ value: cat, label: toTitleCase(cat) }))
        return (
            <div >
                <Modal className="repAssignmentModal" isOpen={this.props.open}>
                    <ModalHeader>{this.props.title ? this.props.title : "Assign Drivers to Reps"}</ModalHeader>
                    <ModalBody>
                        <Row>
                            {this.state.error && <Col xs={12}><Alert color="danger">{this.state.error}</Alert></Col>}
                            <Col xs={12} style={{ marginBottom: 15 }}>
                                <Label style={{ fontWeight: 500 }}>Assignment Category</Label>
                                <Select
                                    className="bos-custom-select" classNamePrefix="bos-select"
                                    value={categoryOptions.find(opt => opt.value === this.state.selectedCategory) || null}
                                    onChange={this.handleCategoryChange}
                                    options={categoryOptions}
                                    isDisabled={categoryOptions.length === 1}
                                    placeholder={"Select Assignment Category"}
                                />
                            </Col>
                            {this.props.loading && <Col xs={12}>Loading reps list...</Col>}
                            {this.state.assignmentSuccess ?
                                <Col xs={12}>
                                    <Alert color="success">Assignments created successfully!</Alert>
                                </Col> :
                                <div className='scrollable-table-wrapper'>
                                    <Label style={{ fontWeight: 500 }}>Select Representative</Label>
                                    <Table responsive striped className="table-sm">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col" className="text-center">#</th>
                                                <th scope="col">Collector Name</th>
                                                <th scope="col">Assigned Customers</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.allReps && this.props.allReps.edges && this.props.allReps.edges.map((rep, i) =>
                                                <tr key={rep.node.id}>
                                                    <td className="listing-checkbox-wrapper">
                                                        {!this.state.selectedReps.includes(rep.node.id) && <span className="listing-counter">{i + 1}</span>}
                                                        <span className="listing-checkbox" onClick={() => this.toggleRep(rep.node.id)}>
                                                            {this.state.selectedReps.includes(rep.node.id) ? <i className="fa fa-check-square-o" aria-hidden="true"></i> : <i className="fa fa-square-o unchecked" aria-hidden="true"></i>}
                                                        </span>
                                                    </td>
                                                    <td style={{ textTransform: "capitalize" }}>{rep.node.name}</td>
                                                    <td>{rep.node.assignedCount}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            }
                        </Row>
                        {this.state.loading && <Row><Col xs={12}><Progress animated color="info" value="100" /></Col></Row>}
                    </ModalBody>
                    <ModalFooter>
                        {!this.state.loading &&
                            <>
                                <Button outline color="secondary" onClick={this.handleClose}>Close</Button>&nbsp;&nbsp;
                                <Button color="primary" onClick={this.runAutoAssign} disabled={this.state.loading || this.state.assignmentSuccess || this.state.selectedReps.length === 0}>Create Assignment</Button>
                            </>
                        }
                    </ModalFooter>
                </Modal>
            </div >
        )
    }
}


export default graphql(RepsQuery, {
    options: ({ group }) => ({ variables: { groups: [group] }, }),
    props: ({ data, loading }) => ({
        allReps: data?.allReps || [],
        loading
    }),
}
)(withApolloClient(RepAssignmentModal));

